import httpbaseURL from '../../../../modules/Inventory/common/axios';
class SubAssetRelationshipServices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/SubAssetRelationship/Create", doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/SubAssetRelationship/Update", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/SubAssetRelationship/ListAssign")
    }
    getAssetOutsidePremisesList() {
        return httpbaseURL.httpMSInventoryUrl.get("/SubAssetRelationship/AssetOutsidePremisesList")
    }
    getDashboarddata() {
        return httpbaseURL.httpMSInventoryUrl.get("/SubAssetRelationship/ListAssignDashboard")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/SubAssetRelationship/ListSubAssetRelationshipByAssetMasterId?AssetId=" + doc)
    }
    listSubAssetByItemId(doc, HId, BId, SId) {
        return httpbaseURL.httpMSInventoryUrl.get("/SubAssetRelationship/ListSubAssetRelationshipByItemId?ItemId=" + doc
            + "&HospitalId=" + HId + "&BranchId=" + BId + "&StoreId=" + SId)
    }
    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/SubAssetRelationship/Delete?ID=" + doc)
    }
}
export default new SubAssetRelationshipServices()